import JobTagApi from "../generated/api/JobTagApi";
import SaveJobTagRequest from "../generated/model/SaveJobTagRequest";

class JobTagService {
  constructor() {
    this.JobTagApi = new JobTagApi();
  }

  async GetAll() {
    return await window.$A.HandleApiResponse(
      this.JobTagApi.getAllJobTags(),
      ""
    );
  }

  async updateJobTagById(jobTagId, jobTagData) {
    const jobTagUpdateRequest = { jobTagId, jobTagData };
    return await window.$A.HandleApiResponse(
      this.JobTagApi.updateJobTag({ jobTagUpdateRequest }),
      "Job Tag Updated"
    );
  }

  async Delete(jobTagId) {
    return await window.$A.HandleApiResponse(
      this.JobTagApi.deleteJobTag(jobTagId),
      "Job Tag Deleted"
    );
  }

  async Save(saveJobTagRequest) {
    if (saveJobTagRequest.id && saveJobTagRequest.id > 0) {
      const jobTagUpdateRequest = {
        jobTagId: saveJobTagRequest.id,
        jobTagData: { name: saveJobTagRequest.name },
      };
      return await window.$A.HandleApiResponse(
        this.JobTagApi.updateJobTag({ jobTagUpdateRequest }),
        "Job Tag Updated"
      );
    } else {
      // Create new tag
      const createRequest = new SaveJobTagRequest(saveJobTagRequest.name);
      return await window.$A.HandleApiResponse(
        this.JobTagApi.createJobTag({ saveJobTagRequest: createRequest }),
        "Job Tag Created"
      );
    }
  }

  async UpdateAndDeleteTagLink({ jobId, update, delete: toDelete }, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = false;
    }
    const modifyJobTagLinkRequest = {
      jobId,
      update: Array.isArray(update) ? update : [],
      delete: Array.isArray(toDelete) ? toDelete : [],
    };
    return await window.$A.HandleApiResponse(
      this.JobTagApi.updateAndDeleteTagLink({ modifyJobTagLinkRequest }),
      "Tags Updated Successfully",
      preventAlert
    );
  }
}

export default JobTagService;
